import { action, makeAutoObservable, observable } from 'mobx'
import { persist } from 'mobx-persist'
import moment, { Moment } from 'moment'

export interface SnoozedReminder {
  readonly id: string
  readonly name: string
  readonly nextRemindTime: Moment
  readonly muted?: boolean
}

class ReminderStore {
  @persist('object')
  @observable
  snoozedReminders: Array<SnoozedReminder> = []

  @persist('object')
  @observable
  remindersMuted: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  @action
  addSnoozedReminder(snoozedReminder: SnoozedReminder): void {
    this.snoozedReminders = this.snoozedReminders.concat(snoozedReminder)
  }

  @action
  addSnoozedReminders(snoozedReminders: SnoozedReminder[]): void {
    this.snoozedReminders = this.snoozedReminders.concat(snoozedReminders)
  }

  @action
  purgeOldReminders(): void {
    const now = moment(new Date())
    this.snoozedReminders = this.snoozedReminders.filter((snoozedReminder) =>
      moment(snoozedReminder.nextRemindTime).isAfter(now),
    )
  }

  @action
  removeAllSnoozedReminders(): void {
    this.snoozedReminders = []
  }

  @action
  toggleMute(): void {
    this.remindersMuted = !this.remindersMuted
  }
}

export default new ReminderStore()
